<template>
  <div>
    <span v-if="hasConnectToSupport">{{ $t('chat.sys.navigation.connect_here') }}</span>
    <div v-if="hasConnectToSupport" class="categories">
      <div class="item" @click="buildAlternativeActionEvent(PredefinedOptionType.CONNECT_TO_SUPPORT)">
        <CustomerSupportIcon />
        <span>{{ $t('chat.sys.navigation.contact_support') }}</span>
      </div>
    </div>
    <span>
      {{ $t('chat.sys.navigation.different_topic') }}
    </span>
    <span class="restart-text">
      {{ $t('chat.sys.navigation.restart_here') }}
    </span>
    <div class="categories">
      <div class="item" @click="buildAlternativeActionEvent(PredefinedOptionType.RESTART_CHAT)">
        <span>{{ $t('chat.sys.navigation.restart_chat') }}</span>
      </div>
    </div>
    <span v-if="hasDirectRequest" class="direct-request-text">
      {{ $t('chat.sys.navigation.ticket_created') }}
    </span>
    <div v-if="hasDirectRequest" class="categories">
      <div class="item" @click="buildAlternativeActionEvent(PredefinedOptionType.GO_TO_TICKET)">
        <span>{{ $t('chat.sys.navigation.go_to_ticket') }}</span>
      </div>
    </div>
    <span>{{ $t('chat.sys.navigation.end_chat_here') }}</span>
    <div class="categories">
      <div class="item" @click="buildAlternativeActionEvent(PredefinedOptionType.END_CHAT)">
        <span>{{ $t('global.end_chat') }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { PredefinedAltActionOptions, PredefinedOptionType, SystemEvent } from '@/common/bot/enum';
import { canConnectToAgent } from '@/common/bot/lib';
import { AlternativeActionSelectedEvent, BaseSystemMessage } from '@/common/bot/types';
import CustomerSupportIcon from '@/components/icons/CustomerSupportIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    CustomerSupportIcon,
  },
})
export default class AlternativeActionsMessage extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: BaseSystemMessage;

  readonly PredefinedOptionType = PredefinedOptionType;

  get hasDirectRequest() {
    return !!this.message.config?.directRequest;
  }

  get hasConnectToSupport() {
    return canConnectToAgent(this.message.config?.connect);
  }

  buildAlternativeActionEvent(selected: PredefinedAltActionOptions) {
    const $event: AlternativeActionSelectedEvent = {
      message: this.message,
      type: SystemEvent.ALTERNATIVE_ACTION,
      payload: { selected },
    };

    this.$emit('send:event', $event);
  }
}
</script>

<style scoped lang="scss">
.categories {
  .item {
    svg,
    span {
      margin: 0 0 0 8px;
    }
  }
}

.restart-text,
.direct-request-text {
  display: block;
  margin-top: 16px;
}
</style>
